// Český vokativ pro oslovení (Michaela → Michaelo, Petr → Petře, ...).
// Hardcoded přesné tvary + heuristika pro fallback.
// Použito v Dashboard hero + Fakturace headline + (případně) další oslovení.
export function toVocativ(jmeno) {
  if (!jmeno) return "";
  const first = String(jmeno).trim().split(/\s+/)[0] || "";
  if (!first) return jmeno;
  const lower = first.toLowerCase();
  const overrides = {
    "petr": "Petře", "tomas": "Tomáši", "tomáš": "Tomáši",
    "jakub": "Jakube", "michal": "Michale", "jan": "Jane",
    "ladislav": "Ladislave", "pavel": "Pavle", "karel": "Karle",
    "marek": "Marku", "ondrej": "Ondřeji", "ondřej": "Ondřeji",
    "matej": "Matěji", "matěj": "Matěji",
    "ales": "Aleši", "aleš": "Aleši",
    "lukas": "Lukáši", "lukáš": "Lukáši",
    "david": "Davide", "robert": "Roberte", "filip": "Filipe",
    "martin": "Martine", "milan": "Milane", "marian": "Mariane",
    "jiri": "Jiří", "jiří": "Jiří",
    "vaclav": "Václave", "václav": "Václave",
    "frantisek": "Františku", "františek": "Františku",
    "vojtech": "Vojtěchu", "vojtěch": "Vojtěchu",
    "stepan": "Štěpáne", "štěpán": "Štěpáne",
    "dominik": "Dominiku", "rene": "René",
    // ženská
    "michaela": "Michaelo", "jana": "Jano", "petra": "Petro",
    "katerina": "Kateřino", "kateřina": "Kateřino",
    "lenka": "Lenko", "alena": "Aleno", "marie": "Marie",
    "anna": "Anno", "eva": "Evo", "monika": "Moniko",
    "veronika": "Veroniko", "klara": "Kláro", "klára": "Kláro",
    "barbora": "Barboro", "tereza": "Terezo", "natalie": "Natálie",
    "pavla": "Pavlo", "iveta": "Iveto", "lucie": "Lucie",
    "hana": "Hano", "denisa": "Deniso", "kristyna": "Kristýno",
    "simona": "Simono", "andrea": "Andreo", "magdalena": "Magdaleno",
  };
  if (overrides[lower]) return overrides[lower];
  const last = lower.charAt(lower.length - 1);
  if (last === "a") return first.slice(0, -1) + "o";
  if (/[ščžřj]$/.test(lower)) return first + "i";
  if (/[bcdfghklmnprstvwxz]$/.test(lower)) return first + "e";
  return first;
}
